import React from "react"

export default function NoCheckmark() {
   return (
      <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
         <circle cx="9.64746" cy="9.47559" r="8.5" fill="white" stroke="#B8BAC2" />
      </svg>
   )
}
